/**
 * Navigation List Component
 * Renders the list of navigation items with dividers
 */

import React from 'react';
import { List, Divider } from '@mui/material';
import { NavItem } from './NavItem';
import { navItems, filterNavItemsByWorkspaceRole } from './navItems';
import { useCurrentWorkspaceRole } from '@/features/workspaces/hooks/useCurrentWorkspaceRole';

interface NavListProps {
  collapsed: boolean;
}

/**
 * Nav List Component
 * Renders all navigation items filtered by workspace role
 */
export const NavList: React.FC<NavListProps> = ({ collapsed }) => {
  const workspaceRole = useCurrentWorkspaceRole();

  // Filter items based on workspace role
  const filteredItems = filterNavItemsByWorkspaceRole(navItems, workspaceRole);

  return (
    <List>
      {filteredItems.map((item, index) => (
        <React.Fragment key={item.id}>
          {/* Divider before item if specified */}
          {item.divider && index > 0 && <Divider component="li" sx={{ my: 1 }} />}

          {/* Navigation Item */}
          <NavItem item={item} collapsed={collapsed} />
        </React.Fragment>
      ))}
    </List>
  );
};
